export default "__VITE_PUBLIC_ASSET__21041a8b__"